import { Button, OpenIcon } from "../../components/ui";
import type { ModelReference } from "../lib/modelReferences";

export default function AgentReviewModelLink({
  children,
  title,
  reference,
  value = false,
  onOpenModelReference,
}: {
  children: string;
  title: string;
  reference: ModelReference;
  value?: boolean;
  onOpenModelReference: (reference: ModelReference) => void;
}) {
  return (
    <Button
      type="button"
      tone="quiet"
      size="xs"
      className={[
        "agent-review-model-link",
        value ? "agent-review-model-link--value" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      iconRight={<OpenIcon />}
      title={title}
      onClick={() => onOpenModelReference(reference)}
    >
      {children}
    </Button>
  );
}
